/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as Utils from '@Cyclope-Utils/index';
import {ExtrairePdfTmdActionFail, ExtrairePdfTmdActionInProgress, ExtrairePdfTmdActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function ExtrairePdfTmdActionCreator
 * @param { any }  incidentParams
 * @return {Promise<any>}  Promise
 */
export function ExtrairePdfTmdActionCreator(incidentParams: any): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ExtrairePdfTmdActionInProgress());

        await Utils.downloadLapiPdf(incidentParams)
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.blob().then((data: any) => {
              dispatch(ExtrairePdfTmdActionSuccess(data + `${Math.random()}`));
              const file = new Blob([data], {type: 'application/pdf'});
              const urlz = window.URL.createObjectURL(file);
              const a = document.createElement('a');
              a.href = urlz;
              a.download =
                  'export_cam_lapi_tmd_pdf_id_' + incidentParams + '.pdf';

              document.body.appendChild(a);
              a.click();
              a.remove();
            });  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(ExtrairePdfTmdActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.blob().then((data: any) => {
              dispatch(ExtrairePdfTmdActionSuccess(data + `${Math.random()}`));
              const file = new Blob([data], {type: 'application/pdf'});
              const urlz = window.URL.createObjectURL(file);
              const a = document.createElement('a');
              a.href = urlz;
              a.download =
                  'export_cam_lapi_tmd_pdf_id_' + incidentParams + '.pdf';

              document.body.appendChild(a);
              a.click();
              a.remove();
            })  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ExtrairePdfTmdActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ExtrairePdfTmdActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/lapi-tmd/extraire-pdf/index.ts